// API Routes Configuration
export const API_ROUTES = {
  // Authentication
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH_TOKEN: '/auth/refresh',
  
  // Dashboard
  DASHBOARD_STATS: '/dashboard/stats',
  
  // Chargers
  CHARGERS: '/chargers',
  CHARGER_START: (id) => `/chargers/${id}/start`,
  CHARGER_STOP: (id) => `/chargers/${id}/stop`,
  CHARGER_STATUS: (id) => `/chargers/${id}/status`,
  
  // Transactions
  TRANSACTIONS: '/transactions',
  TRANSACTION_DETAIL: (id) => `/transactions/${id}`,
  
  // Sessions
  SESSIONS: '/sessions',
  ACTIVE_SESSIONS: '/sessions/active',
  SESSION_DETAIL: (id) => `/sessions/${id}`,
  
  // Alerts
  ALERTS: '/alerts',
  ALERTS_MARK_READ: (id) => `/alerts/${id}/read`,
  
  // Users
  USERS: '/users',
  USER_PROFILE: '/users/profile',
  USER_DETAIL: (id) => `/users/${id}`,
};

// Default credentials for development/demo
export const DEMO_CREDENTIALS = {
  username: 'test@fsdf',
  password: 'fnfknf'
};

export default API_ROUTES;